import { render, staticRenderFns } from "./StartTowers.vue?vue&type=template&id=2dbac24e"
import script from "./StartTowers.vue?vue&type=script&lang=js"
export * from "./StartTowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports